export const ActionButton = () => import('../../components/ActionButton.vue' /* webpackChunkName: "components/action-button" */).then(c => wrapFunctional(c.default || c))
export const HomeButton = () => import('../../components/HomeButton.vue' /* webpackChunkName: "components/home-button" */).then(c => wrapFunctional(c.default || c))
export const NuxtLogo = () => import('../../components/NuxtLogo.vue' /* webpackChunkName: "components/nuxt-logo" */).then(c => wrapFunctional(c.default || c))
export const RemarksPopup = () => import('../../components/RemarksPopup.vue' /* webpackChunkName: "components/remarks-popup" */).then(c => wrapFunctional(c.default || c))
export const SelectParamFooter = () => import('../../components/SelectParamFooter.vue' /* webpackChunkName: "components/select-param-footer" */).then(c => wrapFunctional(c.default || c))
export const SelectSubServices = () => import('../../components/SelectSubServices.vue' /* webpackChunkName: "components/select-sub-services" */).then(c => wrapFunctional(c.default || c))
export const TransferQueuePopUp = () => import('../../components/TransferQueuePopUp.vue' /* webpackChunkName: "components/transfer-queue-pop-up" */).then(c => wrapFunctional(c.default || c))
export const VuetifyLogo = () => import('../../components/VuetifyLogo.vue' /* webpackChunkName: "components/vuetify-logo" */).then(c => wrapFunctional(c.default || c))
export const App = () => import('../../components/AppLayout/App.vue' /* webpackChunkName: "components/app" */).then(c => wrapFunctional(c.default || c))
export const AppFooter = () => import('../../components/AppLayout/AppFooter.vue' /* webpackChunkName: "components/app-footer" */).then(c => wrapFunctional(c.default || c))
export const AppLayout = () => import('../../components/AppLayout/AppLayout.vue' /* webpackChunkName: "components/app-layout" */).then(c => wrapFunctional(c.default || c))
export const AppMenu = () => import('../../components/AppLayout/AppMenu.vue' /* webpackChunkName: "components/app-menu" */).then(c => wrapFunctional(c.default || c))
export const AppProfile = () => import('../../components/AppLayout/AppProfile.vue' /* webpackChunkName: "components/app-profile" */).then(c => wrapFunctional(c.default || c))
export const AppSubmenu = () => import('../../components/AppLayout/AppSubmenu.vue' /* webpackChunkName: "components/app-submenu" */).then(c => wrapFunctional(c.default || c))
export const AppTopbar = () => import('../../components/AppLayout/AppTopbar.vue' /* webpackChunkName: "components/app-topbar" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
